"use client";

import React from "react";
import Button from "@components/atoms/Button";
import styles from "./StickyCTA.module.scss";
import { StickyCTAProps } from "./StickyCTA.types";

export default function StickyCTA({
  stockCount,
  onTalkToUs,
  onGetQuote,
  className,
  isLoggedIn = false,
}: StickyCTAProps) {
  return (
    <div className={`${styles.stickyCTA} ${className || ""}`}>
      {stockCount && stockCount > 0 && (
        <div className={styles.stockAlert}>
          <span>
            {`Only ${stockCount} cars left in stock`}
          </span>
        </div>
      )}
      
      <div className={styles.buttonContainer}>
        {isLoggedIn && (
          <Button
            variant="outline"
            size="lg"
            onButtonClick={onTalkToUs}
            className={styles.talkToUsButton}
          >
            Talk to us
          </Button>
        )}
        
        <Button
          variant="primary"
          size="lg"
          onButtonClick={onGetQuote}
          className={styles.getQuoteButton}
        >
          {isLoggedIn ? "Get a quote" : "Unlock ACKO Drive price"}
        </Button>
      </div>
    </div>
  );
} 